import { CodeLink } from '@amzn/awscat-pattern-library-service-model';
import React, { createContext } from 'react';
import { CodeRepoFormData } from './CodeRepoFormData';

export interface CodeRepoFormCtxData {
  repoData: CodeRepoFormData;
  setRepoData: React.Dispatch<React.SetStateAction<CodeRepoFormData>>;

  invalidFormFields: Set<string>;
  onInputValidation: (fieldId: string, invalid: boolean) => void;

  addRepoToContent: (repoData: CodeLink) => void;

  showValidationErrors?: boolean;
  setShowValidationErrors: (value: boolean) => void;
}

export const CodeRepoFormCtx = createContext<CodeRepoFormCtxData | undefined>(undefined);
